var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          defaultOrderColumn: "created_date_formatted",
          defaultOrderDirection: "asc",
          route_name: "/portal-cebas/credentialings/handlings",
          css_formats: {
            validated_date_formatted: function(status, model) {
              if (status) {
                return "badge badge-glow badge-" + status.color
              } else {
                return ""
              }
            },
            status: function(status, model) {
              return "badge badge-glow badge-" + status.color
            }
          },
          column_formats: {
            status: function(val) {
              return val.label
            }
          }
        },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function(actions) {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-row gap-2" },
                  [
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "portal_cebas.credentialing.handling",
                          expression: "`portal_cebas.credentialing.handling`"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            content: "Tratar formulário",
                            delay: { show: 100, hide: 100 }
                          },
                          expression:
                            "{\n            content: 'Tratar formulário',\n            delay: { show: 100, hide: 100 }\n          }",
                          modifiers: { top: true }
                        }
                      ],
                      staticClass:
                        "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                      attrs: { icon: "EditIcon" },
                      on: {
                        click: function($event) {
                          return _vm.handling(actions.row.id)
                        }
                      }
                    }),
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "portal_cebas.credentialing.handling.detail",
                          expression:
                            "`portal_cebas.credentialing.handling.detail`"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            content: "Detalhar registro",
                            delay: { show: 100, hide: 100 }
                          },
                          expression:
                            "{\n            content: 'Detalhar registro',\n            delay: { show: 100, hide: 100 }\n          }",
                          modifiers: { top: true }
                        }
                      ],
                      staticClass:
                        "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                      attrs: { icon: "EyeIcon" },
                      on: {
                        click: function($event) {
                          return _vm.detail(actions.row.id)
                        }
                      }
                    }),
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "portal_cebas.credentialing.handling.delete",
                          expression:
                            "`portal_cebas.credentialing.handling.delete`"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            content: "Excluir registro",
                            delay: { show: 100, hide: 100 }
                          },
                          expression:
                            "{\n            content: 'Excluir registro',\n            delay: { show: 100, hide: 100 }\n          }",
                          modifiers: { top: true }
                        }
                      ],
                      staticClass:
                        "h-5 w-5 mb-1 mr-1 stroke-current text-danger",
                      attrs: { icon: "Trash2Icon" },
                      on: {
                        click: function($event) {
                          return _vm.destroy(actions.row.id)
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }